import {Injectable, ErrorHandler} from '@angular/core';
import * as StackTrace from 'stacktrace-js';
import {ErrorLogModel} from '../models/error-log.model';
import {LokijsService} from './database/lokijs.service';
import {ConfigurationService} from './configuration.service';
import {HttpClient} from '@angular/common/http';
import {GeneralService} from './general.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {

    constructor(private loki: LokijsService,
                private configuration: ConfigurationService,
                private http: HttpClient,
                private generalService: GeneralService) {
    }

    handleError(error: any): void {
        console.log(error);
        const errorLog = new ErrorLogModel();
        StackTrace.fromError(error).then(errs => {
            errorLog.stackFrames = errs;
        });
        errorLog.date = new Date().toISOString();
        errorLog.url = window.location.href;
        errorLog.message = error.toString();
        errorLog.type = 'exception';
        errorLog.cause = '';
        errorLog.applicationName = 'MobileHireV4';
        errorLog.operator = '' + this.configuration.getConfiguration().selectedOperator;
        errorLog.companyName = this.configuration.getMobileConfiguration().companyName;
        errorLog.companyPhone = this.configuration.getMobileConfiguration().companyPhone;

        // errorLog.device = device;
        // errorLog.applicationVersion = applicationDetails.getApplicationVersion();
        // errorLog.applicationBranch = applicationDetails.getApplicationBranch();

        this.loki.upsert('errorlog', '$loki', errorLog);
        this.http.post(this.configuration.buildErrorLoggingURL(), errorLog)
            .toPromise().then(succ => {
            console.log(succ);
        }).catch(err => {
            console.log(err);
        });
        // this.generalService.createToast('Error Occurred! See logs in settings', 2000);
    }
}
